import React from 'react';
import { Box, Typography, Chip, Paper } from '@mui/material';

function ColorPalette({ colors, title, onColorClick }) {
  if (!colors || colors.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      {title && (
        <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: { xs: 1.5, sm: 2 },
          justifyContent: { xs: 'center', sm: 'flex-start' }
        }}
      >
        {colors.map((color, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: onColorClick ? 'pointer' : 'default',
              minWidth: { xs: 80, sm: 110 },
              maxWidth: { xs: 90, sm: 120 },
            }}
            onClick={() => onColorClick && onColorClick(color)}
          >
            <Box
              sx={{
                width: { xs: 65, sm: 85 },
                height: { xs: 65, sm: 85 },
                backgroundColor: color.hex,
                borderRadius: 2,
                border: '2px solid rgba(255,255,255,0.1)',
                mb: 1,
                transition: 'transform 0.2s',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                '&:hover': onColorClick ? {
                  transform: 'scale(1.1)',
                } : {},
              }}
            />
            <Typography
              variant="caption"
              sx={{
                mb: 0.5,
                fontSize: { xs: '0.7rem', sm: '0.8rem' },
                textAlign: 'center',
                maxWidth: { xs: 85, sm: 115 },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontWeight: 600,
                textTransform: 'capitalize'
              }}
            >
              {color.name || color.hex}
            </Typography>
            {color.reason && (
              <Typography
                variant="caption"
                sx={{
                  mb: 0.5,
                  fontSize: { xs: '0.6rem', sm: '0.7rem' },
                  textAlign: 'center',
                  maxWidth: { xs: 85, sm: 115 },
                  opacity: 0.85,
                  fontStyle: 'italic',
                  color: 'info.light',
                  lineHeight: 1.3,
                  wordWrap: 'break-word',
                  whiteSpace: 'normal'
                }}
              >
                "{color.reason}"
              </Typography>
            )}
            <Chip
              label={color.hex}
              size="small"
              sx={{
                backgroundColor: 'rgba(255,255,255,0.05)',
                fontSize: { xs: '0.6rem', sm: '0.7rem' },
                height: { xs: 20, sm: 24 },
              }}
            />
            {color.rgb && (
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  opacity: 0.7,
                  fontSize: { xs: '0.6rem', sm: '0.75rem' },
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                RGB({color.rgb.r}, {color.rgb.g}, {color.rgb.b})
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default ColorPalette;
